// Avatar.js
// Purpose: Reusable avatar component that displays images with fallback to letter initials
// Logic: Handles image loading errors and displays user/workspace avatars with graceful fallback

import React, { useState } from "react";
import useCommonFunctions from "../hooks/common-functions";

const Avatar = ({
  type = "workspace", // "workspace", "user", or "space"
  data = {}, // workspace object, user object, or space object
  size = "50px",
  fontSize = "20px",
  className = "",
}) => {
  const { getLetters, getBackgroundColor } = useCommonFunctions();
  const [imageError, setImageError] = useState(false);

  // Determine image URL and name based on type
  let imageUrl, name, firstName, lastName, bgColorLetter;

  if (type === "workspace") {
    imageUrl = data?.workspace?.workspace_avtar || data?.workspace_avtar;
    name = data?.workspace?.workspace_name || data?.workspace_name;
    bgColorLetter = name?.charAt(0) || "";
  } else if (type === "space") {
    imageUrl = data?.space_avtar || data?.user_workspace_space?.space_avtar;
    name = data?.space_name || data?.user_workspace_space?.space_name;
    bgColorLetter = name?.charAt(0) || "";
  } else if (type === "user") {
    imageUrl = data?.profile_photo || data?.user_workspace?.profile_photo;
    firstName = data?.first_name || data?.user_workspace?.first_name || "";
    lastName = data?.last_name || data?.user_workspace?.last_name || "";
    name = `${firstName} ${lastName}`.trim();
    bgColorLetter = firstName?.charAt(0) || "";
  }

  const showImage = imageUrl && !imageError;

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div
      style={{
        backgroundColor: showImage
          ? "transparent"
          : getBackgroundColor(bgColorLetter),
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        fontSize: showImage ? "0" : fontSize,
      }}
      className={`text-[#fff] font-semibold rounded-full flex items-center justify-center overflow-hidden ${className}`}
    >
      {showImage ? (
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover"
          onError={handleImageError}
        />
      ) : (
        <span style={{ fontSize }}>
          {type === "user" ? getLetters(firstName, lastName) : getLetters(name)}
        </span>
      )}
    </div>
  );
};

export default Avatar;
